export function whenConsented(key, onConsent, onDecline, options = false) {

    if (!App.config.global.blockCookies || App.isShopBuilder) {
        onConsent();
        return;
    }

    if (window.ConsentManager) {
        if (window.ConsentManager.hasResponse()) {
            window.ConsentManager.isConsented(key) ? onConsent() : onDecline();
        }
        document.addEventListener('consent-change', () => {
            whenConsented(key, onConsent, onDecline);
        }, options);
    }else {
        onConsent();
    }
}
